import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", y = 28, as = "div" }) {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </C>
  );
}

const inner = { hidden: { y: "105%" }, show: { y: 0 } };

// Observer sits on the unclipped outer wrapper; the clipped inner span only follows variants
export function MaskLine({ children, delay = 0, className = "", inView = false }) {
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <motion.span className="block" initial="hidden" {...trigger}>
      <span className="block overflow-hidden pb-[0.14em]">
        <motion.span className={`block ${className}`} variants={inner} transition={{ duration: 1.15, ease: EASE, delay }}>
          {children}
        </motion.span>
      </span>
    </motion.span>
  );
}
